import api from 'api';

export const loadTypes = api('GET /api/annotations/filters/types');
export const loadApplications = api(
  'GET /api/annotations/filters/applications'
);
export const loadAffiliates = api('GET /api/annotations/filters/affiliates');
export const loadNetworks = api('GET /api/annotations/filters/networks');
export const loadClusters = api('GET /api/annotations/filters/clusters');
export const loadPlatforms = api('GET /api/annotations/filters/platforms');
export const loadSubTypesFilter = api('GET /api/annotations/filters/subtypes');
export const loadChannels = api('GET /api/annotations/filters/channels');

export const loadOnlyMineFilter = () => {
  return [
    { id: 0, name: 'All' },
    { id: 1, name: 'Only mine' },
  ];
};
